/**
 * Sesión expirada: cuando un request authed recibe 401 y el refresh falla,
 * redirigimos a /sesion-expirada en vez de dejar el sitio "trabado" con 401
 * silenciosos. El guard evita que múltiples 401 concurrentes disparen múltiples
 * navegaciones (la navegación es location.assign → recarga completa → flag reset).
 */
let triggered = false;

export function triggerSessionExpired(): void {
    if (triggered) return;
    if (typeof window === "undefined") return;
    triggered = true;
    try {
        if (window.location.pathname.startsWith("/sesion-expirada")) return;
        window.location.assign("/sesion-expirada");
    } catch {
        triggered = false;
    }
}

export function isSessionExpiredTriggered(): boolean {
    return triggered;
}
